<section class="px-6 py-20 sm:px-10">
  <div class="mx-auto max-w-md">
    @if (!submitted()) {
      <div class="mb-8">
        <span class="mb-4 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
          >Admit one</span
        >
        <h1 class="font-display text-3xl font-semibold text-parchment">Start your Ghoul Pool</h1>
        <p class="mt-3 text-dusk">Free forever on the starter tier. No card required.</p>
      </div>

      <form
        [formGroup]="form"
        (ngSubmit)="submit()"
        class="flex flex-col gap-5 rounded-md border border-hairline bg-panel p-7"
      >
        <div class="flex flex-col gap-2">
          <label for="displayName" class="text-sm font-medium text-parchment">Display name</label>
          <input
            id="displayName"
            type="text"
            formControlName="displayName"
            autocomplete="name"
            class="rounded border border-hairline bg-ink px-4 py-2.5 text-parchment placeholder:text-dusk/60 focus:border-gold focus:outline-none"
            placeholder="What should we call you?"
          />
          @if (form.controls.displayName.invalid && form.controls.displayName.touched) {
            <p class="text-sm text-wax-bright">A display name is required.</p>
          }
        </div>

        <div class="flex flex-col gap-2">
          <label for="email" class="text-sm font-medium text-parchment">Email</label>
          <input
            id="email"
            type="email"
            formControlName="email"
            autocomplete="email"
            class="rounded border border-hairline bg-ink px-4 py-2.5 text-parchment placeholder:text-dusk/60 focus:border-gold focus:outline-none"
            placeholder="you@example.com"
          />
          @if (form.controls.email.invalid && form.controls.email.touched) {
            <p class="text-sm text-wax-bright">Enter a valid email address.</p>
          }
        </div>

        <div class="flex flex-col gap-2">
          <label for="password" class="text-sm font-medium text-parchment">Password</label>
          <app-password-field>
            <input
              id="password"
              appPasswordInput
              formControlName="password"
              autocomplete="new-password"
              class="w-full rounded border border-hairline bg-ink px-4 py-2.5 text-parchment placeholder:text-dusk/60 focus:border-gold focus:outline-none pr-11"
              placeholder="At least 8 characters"
            />
          </app-password-field>
          @if (form.controls.password.invalid && form.controls.password.touched) {
            <p class="text-sm text-wax-bright">
              8–72 characters, with at least one letter and one number.
            </p>
          }
        </div>

        <div class="flex flex-col gap-2">
          <label for="acceptTerms" class="flex items-start gap-3 text-sm text-dusk">
            <input
              id="acceptTerms"
              type="checkbox"
              formControlName="acceptTerms"
              class="mt-0.5 h-4 w-4 shrink-0 cursor-pointer rounded border border-hairline bg-ink accent-gold focus:outline-none focus:ring-1 focus:ring-gold"
            />
            <span>
              I am 18 or older and I agree to the
              <!-- New tab on purpose: a same-tab navigation would throw away the half-filled form. -->
              <a
                routerLink="/terms"
                target="_blank"
                rel="noopener"
                class="font-medium text-parchment hover:underline"
                >Terms of Service</a
              >
              and
              <a
                routerLink="/privacy"
                target="_blank"
                rel="noopener"
                class="font-medium text-parchment hover:underline"
                >Privacy Policy</a
              >.
            </span>
          </label>
          @if (form.controls.acceptTerms.invalid && form.controls.acceptTerms.touched) {
            <p class="text-sm text-wax-bright">
              You'll need to accept the terms to create an account.
            </p>
          }
        </div>

        @if (errorMessage()) {
          <p class="rounded border border-wax/40 bg-wax/10 px-4 py-3 text-sm text-parchment">
            {{ errorMessage() }}
          </p>
        }

        <button
          type="submit"
          [disabled]="submitting()"
          class="mt-2 inline-flex items-center justify-center rounded-[3px] bg-gradient-to-b from-gold to-gold-dim px-6 py-3 text-sm font-bold text-ink transition hover:-translate-y-px disabled:cursor-not-allowed disabled:opacity-60"
        >
          {{ submitting() ? 'Creating your account…' : 'Create Account' }}
        </button>
      </form>

      <p class="mt-6 text-center text-sm text-dusk">
        Already have an account?
        <a routerLink="/login" class="font-medium text-parchment hover:underline">Log in</a>
      </p>
    } @else {
      <div class="rounded-md border border-gold-dim bg-panel p-9 text-center">
        <span class="mb-4 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
          >Check your inbox</span
        >
        <h1 class="font-display text-2xl font-semibold text-parchment">
          Almost there — verify your email
        </h1>
        <p class="mt-3 text-dusk">
          If that address doesn't already have an account, we've sent a verification
          link to it. Click it to activate your account, then come back and log in.
        </p>
        <a
          routerLink="/login"
          class="mt-7 inline-flex items-center justify-center rounded-[3px] border border-hairline px-6 py-3 text-sm font-semibold text-parchment transition hover:border-parchment"
          >Go to Log In</a
        >
      </div>
    }
  </div>
</section>
